class FamiliaProducto
{
  idFamiliaProducto = 0;
  categoriaProducto_idCategoriaProducto = 0;
  subcategoriaProducto_idSubcategoriaProducto = 0;
  productoPadre = "";
  fechaUltimaModificacion = "";
  enriquecido = false;
  publicado = true;
  iconografia = [];
  usuarios_idUsuario = 0;

  categoriaProducto = undefined;
  subcategoriaProducto = undefined;
  propiedades = [];
  traducciones = [];

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = FamiliaProducto;
